import { addProps, flowMax, addDisplayName } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'
import cx from 'classnames'

import { Button } from './Button'

const useStyles = createUseStyles({
  link: {
    color: 'inherit',
    textDecoration: 'none',
  },
})

interface LinkProps {
  navigateTo: string
  showBackButton?: boolean
  external?: boolean
  noFollow?: boolean
  replace?: boolean
  onClick?: () => void
  additionalState?: Record<string, any>
  reloadDocument?: boolean
}

interface ButtonProps {
  onClick: () => void
}

type Props = { className?: string } & (LinkProps | ButtonProps)

const isLinkProps = (props: Props): props is LinkProps => 'navigateTo' in props

export const LinkOrButton: FC<Props> = flowMax(
  addDisplayName('LinkOrButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  (props) =>
    isLinkProps(props) ? (
      props.external ? (
        /* eslint-disable react/jsx-no-target-blank */
        <a
          href={props.navigateTo}
          target="_blank"
          rel={props.noFollow ? 'nofollow noreferrer' : 'noreferrer'}
          onClick={props.onClick}
          className={cx(props.classes.link, props.className)}
        >
          {props.children}
        </a>
      ) : (
        /* eslint-enable */ <Link
          to={props.navigateTo}
          state={
            props.showBackButton
              ? { ...props.additionalState, showBackButton: true }
              : { ...props.additionalState }
          }
          onClick={props.onClick}
          replace={props.replace}
          className={cx(props.classes.link, props.className)}
          reloadDocument={props.reloadDocument}
        >
          {props.children}
        </Link>
      )
    ) : (
      <Button onClick={props.onClick} className={props.className}>
        {props.children}
      </Button>
    )
)
